export default "__VITE_ASSET__fe8abf77__"